/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaguePlayoffConfig
 */
export interface LeaguePlayoffConfig {
    /**
     * 
     * @type {boolean}
     * @memberof LeaguePlayoffConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof LeaguePlayoffConfig
     */
    qualifyingPositions: number;
    /**
     * 
     * @type {string}
     * @memberof LeaguePlayoffConfig
     */
    format?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaguePlayoffConfig
     */
    playoffTournamentId?: string;
}

/**
 * Check if a given object implements the LeaguePlayoffConfig interface.
 */
export function instanceOfLeaguePlayoffConfig(value: object): value is LeaguePlayoffConfig {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('qualifyingPositions' in value) || value['qualifyingPositions'] === undefined) return false;
    return true;
}

export function LeaguePlayoffConfigFromJSON(json: any): LeaguePlayoffConfig {
    return LeaguePlayoffConfigFromJSONTyped(json, false);
}

export function LeaguePlayoffConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaguePlayoffConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'qualifyingPositions': json['qualifyingPositions'],
        'format': json['format'] == null ? undefined : json['format'],
        'playoffTournamentId': json['playoffTournamentId'] == null ? undefined : json['playoffTournamentId'],
    };
}

export function LeaguePlayoffConfigToJSON(json: any): LeaguePlayoffConfig {
    return LeaguePlayoffConfigToJSONTyped(json, false);
}

export function LeaguePlayoffConfigToJSONTyped(value?: LeaguePlayoffConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'qualifyingPositions': value['qualifyingPositions'],
        'format': value['format'],
        'playoffTournamentId': value['playoffTournamentId'],
    };
}

